import React from "react";
import { Routes, Route } from "react-router-dom";
import PageNotFound from "../pages/pageNotFound/pageNotFound";
import Home from "Samarth Module/components/SamarthHome/Home";
import TabbedView from "Samarth Module/components/tabView/tabView";
import Manpowershortage from "Samarth Module/pages/manpower/manpowerShortage";
import ChatBot from "Samarth Module/pages/chatBot/chatBot";
import Graphs from "Samarth Module/pages/chatBot/graphs";
import MyDashboardsList from "Samarth Module/pages/MyDashboard/Dashboard";
import MyDashboard from "Samarth Module/pages/MyDashboard/MyDashboard";
import AgenticInsights from "Agentic Module/pages/testing/testing";
import EmailTriagePage from "Agentic Module/pages/emailTriaging/emailTriaging";
import Testing from "Agentic Module/pages/testing/testing";

const SamarthRouterHandler = () => {
  return (
    <Routes>
      <Route path="/" element={<TabbedView />} />
      <Route path="alert_details" element={<TabbedView />} />
      <Route path="contract_alert" element={<TabbedView />} />
      <Route path="contract_pr2_alert" element={<TabbedView />} />
      <Route path="norm_alert" element={<TabbedView />} />
      <Route path="agile_or" element={<TabbedView />} />
      <Route path="weekly_or" element={<TabbedView />} />
      <Route path="or_loss_tree" element={<TabbedView />} />
      <Route path="smart_production_scheduler" element={<TabbedView />} />
      <Route path="plan_vs_actuals" element={<TabbedView />} />
      <Route path="supplier_insights" element={<TabbedView />} />
      <Route path="daily_production_insights" element={<TabbedView />} />
      <Route path="manpower_shortage" element={<Manpowershortage />} />
      <Route path="priortization_matrix" element={<TabbedView />} />
      <Route path="admin_portal" element={<TabbedView />} />
      <Route path="ticket_portal" element={<TabbedView />} />
      <Route path="order_visibility" element={<TabbedView />} />
      <Route path="dispatch_priority" element={<TabbedView />} />
      <Route path="po_priority" element={<TabbedView />} />
      <Route path="order_to_delivery_hub" element={<TabbedView />} />
      <Route path="loss_to_action_engine" element={<TabbedView />} />
      <Route path="alert_summary" element={<TabbedView />} />
        <Route path="nr_replenishment_engine" element={<TabbedView />} />
        <Route path="*" element={<PageNotFound />} />


      <Route path="/chat" element={<ChatBot />} />
      <Route path="/chat/:id" element={<ChatBot />} />
      <Route path="/graphs" element={<Graphs />} />
      <Route path="/dashoard-list" element={<MyDashboardsList />} />
      <Route path="/mydashoard/:id" element={<MyDashboard />} />

      <Route path="/demand" element={<TabbedView />} />
    </Routes>
  );
};

export default React.memo(SamarthRouterHandler);
